import {ReportRequest} from '@livongo/protobuf-grpc-external-device-cgm2-report/lib/livongo/protobuf/grpc/external/device/cgm2/report/report_pb';
import {ReportServicePromiseClient} from '@livongo/protobuf-grpc-external-device-cgm2-report/lib/livongo/protobuf/grpc/external/device/cgm2/report/report_grpc_web_pb';
import {
    BoolValue,
    StringValue,
} from 'google-protobuf/google/protobuf/wrappers_pb';
import Arg from '@livongo/arg';

const client = new ReportServicePromiseClient(
    window?.process?.env?.gRPC_URL ?? process.env.gRPC_URL,
    null,
    null
);

// eslint-disable-next-line
const enableDevTools = window.__GRPCWEB_DEVTOOLS__ || (() => {});

// enable debugging grpc calls
enableDevTools([client]);

export const ReportService = async () => {
    const request = new ReportRequest();
    const imagePopValue = new BoolValue();

    imagePopValue.setValue(true);
    request.setImagePopulation(imagePopValue);

    //  const manufacturerNames = ['ABBOTT'];
    const manufacturerNames = [];
    const manufacturerList = manufacturerNames.map(name => {
        const strVal = new StringValue();

        strVal.setValue(name);

        return strVal;
    });

    request.setManufacturerList(manufacturerList);

    request.setName('user/liv/me/device/cgm/report');

    const metadata = {
        Authorization: `Bearer ${Arg('authToken')}`,
    };

    try {
        const resp = await client.getReportPdf(request, metadata);

        return [
            {
                pdfList: resp.getPdfData?.(),
                imageList: setImageList(resp.getImagesList()),
            },
        ];
    } catch (err) {
        console.error(err); // eslint-disable-line no-console
        throw err;
    }

    function setImageList(imgList) {
        const list = [];

        if (imgList) {
            for (let i = 0; i < imgList.length; i++) {
                const obj = {
                    pdfImg: imgList[i].getImage(),
                };

                list.push(obj);
            }
        }

        return list;
    }
};
